import React from "react";

import "./App.css";

import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loggedUserState, toastState } from "./Store/atoms";
import Login from "./Components/Login";
import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps, Color } from "@material-ui/lab/Alert";
import MainPage from "./Components/MainPage";
import { BrowserRouter as Router } from "react-router-dom";
import PopupManager from "./Components/Utilities/index";
import { URL } from "./Models/Fetcher";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function App() {
  const [displayToast, setDisplayToast] = useRecoilState(toastState);

  const handleClose = () => {
    setDisplayToast({ open: false, message: "", severity: "" });
  };

  console.log(process.env.NODE_ENV);
  return (
    <Router>
      <MainPage />
      <PopupManager />

      <Snackbar
        open={displayToast.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={displayToast.severity as Color}>
          {displayToast.message}
        </Alert>
      </Snackbar>
    </Router>
  );
}

export default App;
